
<template>
  <v-layout>
    <v-flex>
      <v-text-field
        v-model="likePatternBrand"
        clearable
        @keyup.enter="getSimilarItems"
        label="Like para la marca"
        prepend-icon="check"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "matching"
);

export default {
  computed: {
    ...mapState(["similarItemsFilters"]),
    likePatternBrand: {
      get() {
        return this.similarItemsFilters.likePatternBrand;
      },
      set(pattern) {
        this.setSimilarItemsFiltersLikePatternBrand(pattern);
      }
    }
  },
  methods: {
    ...mapActions(["getSimilarItems"]),
    ...mapMutations(["setSimilarItemsFiltersLikePatternBrand"])
  }
};
</script>
